import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { UserService } from 'src/app/services/user/user.service';
import { marker as _tMarker } from '@biesbjerg/ngx-translate-extract-marker'

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.sass']
})
export class NotificationSettingsComponent implements OnInit {
  currentUser
  settings: INotificationSetting[]

  get DEFAULTSETTINGS(): INotificationSetting[] {
    const defSettings = [
      /** `_tMarker` ensures that the text is still English for extraction while the actual translation is done in template */
      { name: _tMarker('New projects'), value: false, regex: '^Create Project' },
      { name: _tMarker('Update project details'), value: false, regex: '^Update Project' },
      { name: _tMarker('New uploads'), value: false, regex: '^Upload File' },
      { name: _tMarker('New annotations'), value: false, regex: '^Create Annotation' },
      { name: _tMarker('Edited annotations'), value: false, regex: '^Update Annotation' },
      { name: _tMarker('Deleted annotations'), value: false, regex: '^Remove Annotation' },
      { name: _tMarker('New tasks'), value: false, regex: '^Create Task' },
      { name: _tMarker('Edited tasks'), value: false, regex: '^Update Task' },
      { name: _tMarker('Deleted tasks'), value: false, regex: '^Delete Task' },
      { name: _tMarker('Report exports'), value: false, regex: '^Export Report' },
      { name: _tMarker('New users'), value: false, regex: '^Create User' },
      { name: _tMarker('Edited users'), value: false, regex: '^Update User' },
      { name: _tMarker('Deleted users'), value: false, regex: '^Remove User' },
      { name: _tMarker('Add map layer'), value: false, regex: '^Add MapLayer' },
      { name: _tMarker('Remove map layer'), value: false, regex: '^Remove MapLayer' },
    ]

    return JSON.parse(JSON.stringify(defSettings))
  }

  constructor(
    private userService: UserService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private _t: TranslateService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser))
    const loadSettings: INotificationSetting[] = JSON.parse(localStorage.getItem('notifications'))

    if (loadSettings?.length) {
      /** 
       * Due to previous implementation, the 'name' in LS might get translated into different languages when saving
       * 
       * The changes below is done to use the translated name comes from DEFAULTSETTINGS rather than the one stored in loadSettings
       */
      this.settings = this.DEFAULTSETTINGS.map(defSetting => {
        const loadSetting = loadSettings.find(loadSetting => loadSetting.regex === defSetting.regex)

        defSetting.value = loadSetting?.value
        return defSetting
      })
    }
    else {
      this.settings = this.DEFAULTSETTINGS
    }
  }

  async onClickSave() {
    this.userService.setNotification(this.currentUser.user_id, this.settings).subscribe(res => {
      // localStorage.setItem('notifications', JSON.stringify(this.settings))
      this.dataService.setLocalStorage('notifications', JSON.stringify(this.settings))
      this.toastr.success(this._t.instant('Preferences Saved'))
      this.router.navigate(['..'], { queryParams: { general: true }, relativeTo: this.route })
    })
  }
}

interface INotificationSetting {
  name: string
  value: boolean
  regex: string
}
